import React from 'react';
import { Box, Flex, Placeholder, Text, Fieldset } from '@goodrx/matisse';
import { List } from 'app/components/core/list';
import { Pharmacy } from 'app/types';
import PharmacyItem from '../pharmacy-item';
import { sortPharmaciesByPrice } from './sortPharmaciesByPrice';

interface Search {
  search?: string;
  address?: string;
}

interface PharmacyListProps {
  legend?: string | JSX.Element;
  pharmacies?: Pharmacy[];
  onSelect?: (pharmacy: Pharmacy) => void;
  loading?: boolean;
  search?: Search;
  sortByPrice?: boolean;
}

export const PharmacyList: React.FC<PharmacyListProps> = ({
  legend,
  pharmacies = [],
  onSelect,
  loading = false,
  search,
  sortByPrice,
}) => {
  const searchValue = search?.search ? `containing "${search.search}"` : '';
  const addressValue = search?.address ? ` near ${search.address}` : '';

  if (sortByPrice) {
    pharmacies = sortPharmaciesByPrice(pharmacies);
  }

  return (
    <Box flex={1} style={{ width: '100%' }}>
      <Placeholder loading={loading} delay={0}>
        {pharmacies.length > 0 ? (
          <Fieldset legend={legend || ''}>
            <List
              items={pharmacies as Pharmacy[]}
              render={(pharmacy) => (
                <PharmacyItem key={pharmacy.id} pharmacy={pharmacy} onClick={() => onSelect?.(pharmacy)} />
              )}
            />
          </Fieldset>
        ) : (
          <Box p={2}>
            <Flex mt={3} justifyContent="center">
              <img
                src="/images/illustrations/bottle-pills-bag.png"
                alt="Bottle Pills Bag"
                style={{ maxWidth: '121px' }}
              />
            </Flex>

            <Flex mt={3} justifyContent="center">
              <Text as="p" textAlign="center" fontWeight="500">
                No pharmacies {searchValue} match your search criteria {addressValue}
              </Text>
            </Flex>
          </Box>
        )}
      </Placeholder>
    </Box>
  );
};
